import { CurrentOrganization } from '@shared/services/current-organization'
import { Injectable } from '@angular/core'
import { ErrorPagesService } from '../pages/error-page'

@Injectable({ providedIn: 'root' })
export class TeamModeGuard {
  constructor(
    private currentOrganization: CurrentOrganization,
    private errorPagesService: ErrorPagesService
  ) {}

  canActivate(): boolean {
    if (!this.currentOrganization.team_mode) {
      this.errorPagesService.navigate(404)
      return false
    }
    return true
  }
}
